export const BOTTOM_NAV_AUTO_HIDE = {
    ATTR: "data-km-bottom-nav",
    BOTTOM_LOCK_PX: 68,
    HIDDEN: "hidden",
    SCROLL_DELTA_PX: 2,
    TOP_PX: 8,
    VISIBLE: "visible"
} as const;
export const BOTTOM_NAV_AUTO_HIDE = {
    ATTR: "data-km-bottom-nav",
    BOTTOM_LOCK_PX: 68,
    HIDDEN: "hidden",
    SCROLL_DELTA_PX: 2,
    TOP_PX: 8,
    VISIBLE: "visible"
} as const;
